import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { QUERIES_KEYS, QUERY_STALE_TIME } from 'constant';

interface PendoInformation {
    account: {
        id: string;
        trialExpirationDate: string;
    },
    visitor: {
        id: string;
        username: string;
    },
}

const usePendoInformation = (): () => Promise<PendoInformation> => {
    const queryClient = useQueryClient();

    return useCallback(async () => {
        const { data } = await queryClient.fetchQuery({
            queryKey: [QUERIES_KEYS.PENDO_INFORMATION],
            queryFn: () => axios.get('/api/v1/pendo/pendoInformation'),
            staleTime: QUERY_STALE_TIME.DEFAULT,
        });
        return data;
    }, [queryClient]);
}

export default usePendoInformation;